import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useToast } from '@zet/common/components/toast'
import { i18n } from '@zet/localization'

import { registerUser } from '../functions'

function useRegisterUser() {
  const toast = useToast()
  const queryClient = useQueryClient()

  return useMutation(registerUser, {
    onSuccess(data) {
      const { error } = data.data
      if (error) {
        toast?.show({
          intent: 'error',
          heading: i18n.t('toastMessages.error'),
          description: error,
          hideAfter: 3000,
        })
      } else {
        queryClient.invalidateQueries({
          queryKey: ['userContext'],
        })
      }
    },
  })
}
export { useRegisterUser }
